import React, { Component } from "react";
// import Link from 'next/link';
import styles from './scss/getstarted.module.scss';
import { Button } from 'antd'
class GetStarted extends Component {
    render() {
        return (
            <>

                <div>
                    <div className={`${styles.getstarted}`}>
                        <h3>Let's get to Worktual</h3>
                        <p>Don't forget, your first 5 users are free FOREVER. So what's your excuse?</p>
                        <div className={styles.btnposition}>
                            {/* <h5><Link href="https://partners.worktual.co.uk/become_a_partner.html"><a target="_blank"><Button className="btnAnimBlack"><span>Partner Sign up</span></Button></a></Link></h5> */}
                            <h5><a href="https://worktual.co.uk/pricing" target="_blank"><Button className="btnAnimBlack"><span>Sign up</span></Button></a></h5>
                            {/* <h5><Button className="btnAnimLineBlack"><Link href="/faq"><span>Read more</span></Link></Button></h5> */}
                        </div>
                    </div>
                </div>

            </>
        );
    }
}
export default GetStarted;